import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ColumnConfigEx, ColumnDefinitionEx } from "../../../../@core/types/column-config-types-extended";
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { AddressGroup, DiscountGroupCustomerGroupRelation, DiscountGroupCustomerGroupRelationSearchInput, Operator } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { AddressGroupDropdownComponent } from "../../../crm/controls/address-group-dropdown/address-group-dropdown.component";
import { DiscountGroupCustomerGroupRelationService } from "../../services/discount-group-customer-group-relation.service";

@Component({
  selector: 'app-discount-group-customer-group-relation-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent
  ]
})
export class DiscountGroupCustomerGroupRelationWidgetComponent extends NewBaseListComponent<DiscountGroupCustomerGroupRelation> {

  discountGroupId = input<string>();

  constructor(
    private discountGroupCustomerGroupRelationService: DiscountGroupCustomerGroupRelationService,
  ) {
    super("DiscountGroupCustomerGroupRelation", discountGroupCustomerGroupRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupCustomerGroupRelationSearchInput {
    let si: DiscountGroupCustomerGroupRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  protected override setColumnConfig(colConfig: ColumnConfigEx): void {
    let col: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'customerGroup.identifier' || (x.prop === "identifier" && x.entityType === 'AddressGroup'));
    if (col) {
      col.getEditComponent = () => AddressGroupDropdownComponent;
      col.editComponentCreated = async (c: AddressGroupDropdownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
        if (rowData?.customerGroup)
          c.setModel(rowData.customerGroup);
        else if (rowData?.customerGroupId) {
          await c.loadItemByIdAndSetSelected(rowData.customerGroupId);
          this.cdRef.detectChanges();
        }

        c.value.subscribe(async (x: AddressGroup) => {
          rowData.customerGroupId = x?.id;
        });
      }
    }

    super.setColumnConfig(colConfig);
  }

  override saveInCRUDService(rowData: DiscountGroupCustomerGroupRelation): Promise<DiscountGroupCustomerGroupRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }

}
